import React, { useState } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";

const DeletePostConfirm = ({ post, onConfirm, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      const postRef = doc(db, "PromotionalPosts", post.id);

      await updateDoc(postRef, {
        estado: "eliminado",
        deleted: true,
      });

      // Mostrar modal de éxito
      setShowSuccessModal(true);

      // Esperar 2 segundos antes de cerrar
      setTimeout(() => {
        setShowSuccessModal(false);
        onConfirm();
      }, 2000);
    } catch (error) {
      console.error("Error al marcar la publicación como eliminada:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Confirmación */}
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg max-w-md w-full animate-fade-in-up">
          <h3 className="text-lg font-bold mb-4 text-gray-800 dark:text-gray-100">
            Confirmar eliminación
          </h3>
          <p className="mb-6 text-gray-700 dark:text-gray-300">
            ¿Estás seguro de que deseas eliminar la publicación{" "}
            <strong>{post.title}</strong>? Esta acción no se puede deshacer.
          </p>

          <div className="flex justify-end space-x-3">
            <button
              onClick={onCancel}
              disabled={loading}
              className="px-4 py-2 bg-gray-300 dark:bg-gray-700 text-gray-900 dark:text-white rounded hover:bg-gray-400 dark:hover:bg-gray-600 transition"
            >
              Cancelar
            </button>
            <button
              onClick={handleDelete}
              disabled={loading}
              className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition"
            >
              {loading ? "Eliminando..." : "Eliminar"}
            </button>
          </div>
        </div>
      </div>

      {/* Modal de éxito */}
      {showSuccessModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-2xl max-w-sm w-full text-center animate-fade-in-up">
            <h3 className="text-xl font-bold text-green-600 mb-4">¡Eliminado!</h3>
            <p className="text-gray-700 dark:text-gray-300 mb-6">
              La publicación fue marcada como eliminada exitosamente.
            </p>
            <button
              onClick={() => {
                setShowSuccessModal(false);
                onConfirm();
              }}
              className="bg-green-600 hover:bg-green-700 text-white font-semibold px-6 py-2 rounded-lg transition"
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default DeletePostConfirm;
